/*
 * feurzi-rewards-bar.js — Barre de progression MULTI-PALIERS (V2).
 * INCRÉMENT 1 : rendu de la progression (crans livraison + cadeaux, message dynamique).
 * INCRÉMENT 2 (à venir, nécessite la Function déployée) : machine à états d'ajout des cadeaux
 *   (auto-ajout du défaut avec propriété de ligne `_palier`, changer/retirer, récap « Offert »).
 * Se re-render automatiquement : Dawn recrée l'élément à chaque mise à jour du panier
 * (tiroir + page /cart), donc connectedCallback suffit — pas d'écouteur d'événement nécessaire.
 */
(function () {
  if (window.customElements && customElements.get('rewards-bar')) return;

  function euros(cents) {
    var v = cents / 100;
    // montants ronds sans décimales inutiles : « 49 € » plutôt que « 49,00 € »
    return (v % 1 === 0 ? String(v) : v.toFixed(2).replace('.', ',')) + ' €';
  }

  class RewardsBar extends HTMLElement {
    connectedCallback() {
      try {
        this.render();
      } catch (e) {
        /* ne jamais casser le panier en cas d'erreur de données */
      }
    }

    getPaliers() {
      var el = this.querySelector('.feurzi-rewards2__data');
      if (!el) return [];
      var data = JSON.parse(el.textContent || '[]');
      return data
        .filter(function (p) {
          return p.actif !== false && Number(p.seuil) > 0;
        })
        .map(function (p) {
          p.seuilCents = Math.round(Number(p.seuil) * 100);
          return p;
        })
        .sort(function (a, b) {
          return a.seuilCents - b.seuilCents;
        });
    }

    rewardLabel(p) {
      var parts = [];
      if (p.livraison) parts.push('la livraison offerte');
      if (p.cadeaux && p.cadeaux.length) {
        parts.push('un cadeau' + (p.cadeaux.length > 1 ? ' au choix' : ''));
      }
      return parts.join(' + ') || 'une récompense';
    }

    render() {
      var paliers = this.getPaliers();
      if (!paliers.length) return;

      var total = parseInt(this.dataset.cartTotal || '0', 10);
      var maxSeuil = paliers[paliers.length - 1].seuilCents;
      var next = null;
      for (var i = 0; i < paliers.length; i++) {
        if (paliers[i].seuilCents > total) {
          next = paliers[i];
          break;
        }
      }

      var msg;
      if (!next) {
        msg = '🎉 Toutes les récompenses sont débloquées !';
      } else {
        var reste = next.seuilCents - total;
        var reward =
          next.libelle && next.libelle.length ? next.libelle : this.rewardLabel(next);
        msg = 'Plus que <strong>' + euros(reste) + '</strong> pour débloquer ' + reward;
      }

      var pct = maxSeuil > 0 ? Math.min(100, Math.round((total / maxSeuil) * 100)) : 0;

      var msgEl = this.querySelector('.feurzi-rewards2__msg');
      var trackEl = this.querySelector('.feurzi-rewards2__track');
      if (msgEl) msgEl.innerHTML = msg;
      // La jauge est un dégradé piloté par une variable CSS (voir feuille de style) :
      // un div de remplissage restait invisible dans ce thème.
      if (trackEl) trackEl.style.setProperty('--progression', pct + '%');

      this.renderTicks(paliers, total, maxSeuil);
      this.classList.toggle('feurzi-rewards2--done', !next);
    }

    renderTicks(paliers, total, maxSeuil) {
      var track = this.querySelector('.feurzi-rewards2__track');
      if (!track) return;
      var old = track.querySelectorAll('.feurzi-rewards2__tick');
      for (var i = 0; i < old.length; i++) old[i].remove();

      paliers.forEach(function (p) {
        var reached = total >= p.seuilCents;
        var tick = document.createElement('span');
        tick.className = 'feurzi-rewards2__tick' + (reached ? ' is-reached' : '');
        tick.style.left =
          Math.min(100, maxSeuil > 0 ? (p.seuilCents / maxSeuil) * 100 : 0) + '%';
        var icon = p.livraison ? '🚚' : '🎁';
        tick.innerHTML =
          '<span class="feurzi-rewards2__tick-dot"></span>' +
          '<span class="feurzi-rewards2__tick-label">' +
          icon +
          '<br>' +
          euros(p.seuilCents) +
          '</span>';
        track.appendChild(tick);
      });
    }
  }

  customElements.define('rewards-bar', RewardsBar);
})();
